export default __webpack_public_path__ + "static/media/open_invoice.d4586587.svg";